import { GetterTree } from 'vuex';
import { BulkEditState, RootState } from '../types';

export const getters: GetterTree<BulkEditState, RootState> = {
	getMenuRows(state: BulkEditState): BulkMenuItemRow[] {
		return state.menuRows;
	},

	getLocationRows(state: BulkEditState): BulkLocationRow[] {
		return state.locationRows;
	},

	getCount(state: BulkEditState): number {
		return state.count;
	},

	getSelectedLocationIds(state: BulkEditState): string[] {
		return state.locationIds;
	}
};
